var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { followActions, getCoupons, getEvents, getMemberInfo, getMemberPhotos, getPosts, } from "../../../services/societyWon.services";
import { Storage } from "../../../lib/localstorege.service";
import { useForceUpdate } from "../../../lib/misc.functions";
import "../../../assets/css/sport.color.icon.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { location, member } from "../../../store/login.store";
import _ from "lodash";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router";
import { Location } from "../../../models/user.model";
import { env } from "../../../definitions/global.vars";
import DefaultAvatar from "../../../assets/img/avatar.png";
import ReturnIcon from "../../../assets/feather/x.svg";
import { Api } from '../../register/register.api';
import { useTranslation } from "react-i18next";
var ordering;
export var societywonEventIdMapping = {};
export default function Posts(props) {
    var navigate = useNavigate();
    var _a = useState([]), posts = _a[0], setPosts = _a[1];
    var _b = useState(1), page = _b[0], setPage = _b[1];
    var forceUpdate = useForceUpdate();
    var _c = useState(true), hasMore = _c[0], setHasMore = _c[1];
    var _d = useState(null), userInfo = _d[0], setUserInfo = _d[1];
    var i18n = useTranslation().i18n;
    var base = '/' + i18n.resolvedLanguage;
    var _e = useState(false), postCommentModal = _e[0], setPostCommentModal = _e[1];
    // @ts-ignore
    var _f = props.contentType, contentType = _f.contentType, setContentType = _f.setContentType;
    var profileMember;
    if (props && props.parentParams) {
        profileMember = props.parentParams.memberId;
    }
    else {
        profileMember = member.id;
    }
    var postId = null;
    if (props && props.parentParams) {
        postId = props.parentParams.postId;
    }
    var pages = {
        'zaman-tuneli': {
            title: 'Zaman Tüneli',
            subPage: {
                tumu: {
                    url: "/misc/api/get-posts/",
                    param: {
                        ordering: '-create_date',
                        only_playable: true,
                        page: 0,
                    }
                },
                kuponlarim: {
                    url: "/misc/api/get-posts/",
                    param: {
                        ordering: '-create_date',
                        content_type: 2,
                        only_playable: true,
                        page: 0,
                    }
                },
                tuyolar: {
                    url: "/misc/api/get-posts/",
                    param: {
                        ordering: '-create_date',
                        only_playable: true,
                        content_type: '0,1',
                        page: 0,
                    }
                },
            }
        },
        'anasayfa': {
            title: 'Zaman Tüneli',
            subPage: {
                tumu: {
                    url: "/misc/api/get-posts/",
                    param: {
                        ordering: '-create_date',
                        only_playable: true,
                        page: 0,
                    }
                },
                kuponlarim: {
                    url: "/misc/api/get-posts/",
                    param: {
                        ordering: '-create_date',
                        content_type: 2,
                        only_playable: true,
                        page: 0,
                    }
                },
                tuyolar: {
                    url: "/misc/api/get-posts/",
                    param: {
                        ordering: '-create_date',
                        only_playable: true,
                        content_type: '0,1',
                        page: 0,
                    }
                },
            }
        },
        'takip-ettiklerimin-paylasimlari': {
            title: 'Takip Ettiklerimin Paylaşımları',
            subPage: {
                tumu: {
                    url: "/misc/api/get-posts/",
                    param: {
                        ordering: '-create_date',
                        only_playable: true,
                        'get-followed': true,
                        token: null,
                        page: 0,
                    }
                },
                kuponlarim: {
                    url: "/misc/api/get-posts/",
                    param: {
                        ordering: '-create_date',
                        content_type: 2,
                        only_playable: true,
                        'get-followed': true,
                        token: null,
                        page: 0,
                    }
                },
                tuyolar: {
                    url: "/misc/api/get-posts/",
                    param: {
                        ordering: '-create_date',
                        only_playable: true,
                        content_type: '0,1',
                        'get-followed': true,
                        token: null,
                        page: 0,
                    }
                },
            }
        },
        'profilim': {
            title: 'Profilim',
            subPage: {
                tumu: {
                    url: "/misc/api/get-posts/",
                    param: {
                        ordering: '-create_date',
                        member_id: profileMember,
                        token: null,
                        page: 0,
                    }
                },
                kuponlarim: {
                    url: "/misc/api/get-posts/",
                    param: {
                        ordering: '-create_date',
                        member_id: profileMember,
                        content_type: 2,
                        token: null,
                        page: 0,
                    }
                },
                tuyolar: {
                    url: "/misc/api/get-posts/",
                    param: {
                        ordering: '-create_date',
                        member_id: profileMember,
                        content_type: '0,1',
                        token: null,
                        page: 0,
                    }
                },
                begendiklerim: {
                    url: "/misc/api/get-posts/",
                    param: {
                        ordering: '-create_date',
                        get_liked: profileMember,
                        token: null,
                        page: 0,
                    }
                },
                takipciler: {
                    url: "/misc/api/get-member-info/",
                    param: {
                        followed_by: profileMember,
                        token: null,
                        page: 0,
                    }
                },
                'takip-edilenler': {
                    url: "/misc/api/get-member-info/",
                    param: {
                        following_by: profileMember,
                        token: null,
                        page: 0,
                    }
                },
                paylasim: {
                    url: "/misc/api/get-posts/",
                    param: {
                        post_id: postId,
                        token: null,
                    }
                }
            }
        },
        'profil': {
            title: 'Profil',
            subPage: {
                tumu: {
                    url: "/misc/api/get-posts/",
                    param: {
                        ordering: '-create_date',
                        member_id: profileMember,
                        token: null,
                        page: 0,
                    }
                },
                kuponlarim: {
                    url: "/misc/api/get-posts/",
                    param: {
                        ordering: '-create_date',
                        member_id: profileMember,
                        content_type: 2,
                        token: null,
                        page: 0,
                    }
                },
                tuyolar: {
                    url: "/misc/api/get-posts/",
                    param: {
                        ordering: '-create_date',
                        member_id: profileMember,
                        content_type: '0,1',
                        token: null,
                        page: 0,
                    }
                },
                takipciler: {
                    url: "/misc/api/get-member-info/",
                    param: {
                        followed_by: profileMember,
                        token: null,
                        page: 0,
                    }
                },
                'takip-edilenler': {
                    url: "/misc/api/get-member-info/",
                    param: {
                        following_by: profileMember,
                        token: null,
                        page: 0,
                    }
                },
                paylasim: {
                    url: "/misc/api/get-posts/",
                    param: {
                        post_id: postId,
                        token: null,
                    }
                }
            }
        },
        'en-populer-kuponlar': {
            title: 'En Popüler Kuponlar',
            url: "/misc/api/get-popular-coupons/",
            param: { only_playable: true, ordering: '-hit', token: null }
        },
    };
    var setParams = function (newParams) {
        var conf = pages[props.subpage].subPage ? pages[props.subpage].subPage[contentType] : pages[props.subpage];
        for (var _i = 0, _a = Object.entries(newParams); _i < _a.length; _i++) {
            var _b = _a[_i], k = _b[0], v = _b[1];
            conf.param[k] = v;
        }
        ordering = conf.param.ordering;
        setPage(1);
        getFirstPage();
    };
    var getFirstPage = function () {
        // setHasMore(false)
        setPosts([]);
        var conf = pages[props.subpage].subPage ? pages[props.subpage].subPage[contentType] : pages[props.subpage];
        if (conf) {
            if (conf.param) {
                if (conf.param.hasOwnProperty('token')) {
                    conf.param.token = Storage.get('token');
                }
            }
            if (conf.url) {
                ordering = conf.param.ordering;
                if (props.contentType.contentType == 'takipciler' || props.contentType.contentType == 'takip-edilenler') {
                    getMemberInfo(conf.param).then(function (result) {
                        if (result.length === 0 || result.length < 10) {
                            setHasMore(false);
                        }
                        var loading = document.getElementById('innerLoading');
                        if (loading)
                            loading.style.display = 'none';
                        setPosts(result);
                    });
                }
                else {
                    setPosts([]);
                    getPosts(conf.url, conf.param).then(function (response) {
                        if (response && response !== undefined) {
                            if (response.length === 0 || response.length < 10) {
                                setHasMore(false);
                            }
                            var uniqeMemberId = _.uniq(_.map(response, 'member_id'));
                            getMemberPhotos(uniqeMemberId).then(function (members) {
                                if (members && members.status) {
                                    response.forEach(function (item) {
                                        item.member = members.data.find(function (member) { return (member.member_id === item.member_id); });
                                    });
                                }
                                var couponIds = response.filter(function (el) { return el.content_type === 2; }).map(function (el) {
                                    return el.obj_id;
                                });
                                var eventList = response.filter(function (el) { return el.content_type === 1; }).map(function (el) {
                                    return el.obj_id;
                                });
                                if (couponIds.length > 0) {
                                    getCoupons(couponIds).then(function (coupons) {
                                        coupons.forEach(function (c) {
                                            if (c.slip_rows) {
                                                eventList.push.apply(eventList, eventList.concat(c.slip_rows.map(function (r) { return r.event_id; })));
                                            }
                                        });
                                        response.forEach(function (item) {
                                            item.coupon = coupons.find(function (coupon) { return (coupon.coupon_id === item.obj_id); });
                                        });
                                        var uniqeEventId = _.uniq(eventList);
                                        if (uniqeEventId.length > 0) {
                                            getEvents(uniqeEventId).then(function (events) {
                                                for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
                                                    var event_1 = events_1[_i];
                                                    societywonEventIdMapping[Number(event_1.eventId)] = event_1;
                                                }
                                                // fillEventStatistics(uniqeEventId).then(() => {
                                                var loading = document.getElementById('innerLoading');
                                                if (loading)
                                                    loading.style.display = 'none';
                                                setPosts(response);
                                                // }).catch(() => {
                                                //     const loading = document.getElementById('innerLoading')
                                                //     if (loading) loading.style.display = 'none';
                                                //     setPosts(response);
                                                // })
                                            });
                                        }
                                        else {
                                            var loading = document.getElementById('innerLoading');
                                            if (loading)
                                                loading.style.display = 'none';
                                            setPosts(response);
                                        }
                                    });
                                }
                                else {
                                    var uniqeEventId = _.uniq(response.map(function (el) {
                                        return el.obj_id;
                                    }));
                                    if (uniqeEventId.length > 0) {
                                        getEvents(uniqeEventId).then(function (events) {
                                            for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
                                                var event_2 = events_2[_i];
                                                societywonEventIdMapping[Number(event_2.eventId)] = event_2;
                                            }
                                            setPosts(response);
                                        });
                                    }
                                    else {
                                        setPosts(response);
                                    }
                                }
                            });
                        }
                        else {
                            setHasMore(false);
                        }
                    });
                }
            }
            else {
            }
        }
    };
    useEffect(function () {
        getFirstPage();
        return function () {
            setPosts([]);
        };
    }, [props.subpage, contentType, props.parentParams]);
    useEffect(function () {
        if ((props.subpage === 'profilim' || props.subpage === 'profil') && !isNaN(Number(profileMember))) {
            getMemberInfo({ member_id: profileMember }).then(function (result) {
                var memberIds = [];
                memberIds.push(Number(profileMember));
                getMemberPhotos(memberIds).then(function (response) {
                    result[0].photo = response.data[0].photo;
                    Api.start('get', 'https://cdn.1xwon.com/json/editors.json?v=6', null, false).then(function (response) {
                        if (response.status) {
                            if (response.data.find(function (x) { return x.member_id == result[0].member_id; })) {
                                result[0].title = response.data.find(function (x) { return x.member_id == result[0].member_id; }).title;
                            }
                            setUserInfo(result[0]);
                        }
                    });
                });
            });
        }
        setPosts([]);
    }, [profileMember, contentType, props.subpage]);
    var fetchMoreData = function () {
        var conf = pages[props.subpage].subPage ? pages[props.subpage].subPage[contentType] : pages[props.subpage];
        if (conf.param.hasOwnProperty('token')) {
            conf.param.token = Storage.get('token');
        }
        conf.param.page = page;
        if (!(props.contentType.contentType == 'takipciler' || props.contentType.contentType == 'takip-edilenler')) {
            conf.param.ordering = ordering;
        }
        else {
            getMemberInfo(conf.param).then(function (response) {
                var loading = document.getElementById('innerLoading');
                if (loading)
                    loading.style.display = 'none';
                if (response.length === 0 || response.length < 10) {
                    setHasMore(false);
                }
                posts.push.apply(posts, response);
                setPage(page + 1);
            });
        }
        getPosts(conf.url, conf.param).then(function (response) {
            if (response.length === 0 || response.length < 10) {
                setHasMore(false);
            }
            var uniqeMemberId = _.uniq(_.map(response, 'member_id'));
            if (uniqeMemberId.length > 0) {
                getMemberPhotos(uniqeMemberId).then(function (members) {
                    if (members && members.status) {
                        response.forEach(function (item) {
                            item.member = members.data.find(function (member) { return (member.member_id === item.member_id); });
                        });
                    }
                    var couponIds = response.filter(function (p) { return p.content_type === 2; }).map(function (el) {
                        return el.obj_id;
                    });
                    var eventList = [];
                    getCoupons(couponIds).then(function (coupons) {
                        coupons.forEach(function (c) {
                            if (c.event_id) {
                                eventList.push.apply(eventList, eventList.concat(c.slip_rows.map(function (r) { return r.event_id; })));
                            }
                        });
                        response.filter(function (o) { return o.content_type === 1; }).map(function (el) {
                            return el.obj_id;
                        }).forEach(function (e) {
                            eventList.push(e);
                        });
                        response.forEach(function (item) {
                            item.coupon = coupons.find(function (coupon) { return (coupon.coupon_id === item.obj_id); });
                        });
                        var uniqeEventId = _.uniq(eventList);
                        if (uniqeEventId.length > 0) {
                            getEvents(uniqeEventId).then(function (events) {
                                for (var _i = 0, events_3 = events; _i < events_3.length; _i++) {
                                    var event_3 = events_3[_i];
                                    societywonEventIdMapping[Number(event_3.eventId)] = event_3;
                                }
                                // fillEventStatistics(uniqeEventId).then(() => {
                                posts.push.apply(posts, response);
                                setPage(page + 1);
                                // }).catch(() => {
                                //     posts.push(...response)
                                //     setPage(page + 1);
                                // })
                            });
                        }
                        else {
                            posts.push.apply(posts, response);
                            setPage(page + 1);
                        }
                    });
                });
            }
            else {
                setPage(page + 1);
            }
        });
    };
    // const fetchMoreData = () => {
    //   const conf = pages[props.subpage].subPage ? pages[props.subpage].subPage[contentType] : pages[props.subpage];
    //   if (conf.param.hasOwnProperty('token')) {
    //     conf.param.token = Storage.get('token');
    //   }
    //   conf.param.page = page;
    //   if(props.contentType.contentType == 'takipciler' || props.contentType.contentType == 'takip-edilenler'){
    //     getMemberInfo(conf.param).then(
    //         (response: any) => {
    //           const loading = document.getElementById('innerLoading')
    //           if(loading) loading.style.display = 'none';
    //           if(response.length === 0){
    //             setHasMore(false)
    //           }
    //           societywonUser.push(...response)
    //           setPage(page + 1);
    //           setsocietywonUser(societywonUser)
    //            setPosts([])
    //         })
    //
    //   }else{
    //     conf.param.ordering = ordering;
    //     getPosts(conf.url, conf.param).then((response: Post[]) => {
    //       if(response.length === 0){
    //         setHasMore(false)
    //       }
    //       const uniqeMemberId: any = _.uniq(_.map(response, 'member_id'))
    //       if (uniqeMemberId.length > 0) {
    //         getMemberPhotos(uniqeMemberId).then((members: any) => {
    //           if (members && members.status) {
    //             response.forEach((item: Post) => {
    //               item.member = members.data.find((member: any) => (member.member_id === item.member_id))
    //             })
    //           }
    //           const couponIds = response.filter((p:any)=>p.content_type===2).map((el: any) => {
    //             return el.obj_id
    //           });
    //
    //           let eventList: any = [];
    //           getCoupons(couponIds).then((coupons: any) => {
    //
    //             coupons.forEach((c: any) => {
    //               if (c.event_id) {
    //                 eventList.push(...eventList.concat(c.slip_rows.map((r:any)=>r.event_id)))
    //               }
    //             })
    //
    //             response.filter((o:any)=>o.content_type===1).map((el: any) =>{return el.obj_id}).forEach((e:any)=>{
    //               eventList.push(e);
    //             })
    //
    //             response.forEach((item: Post) => {
    //               item.coupon = coupons.find((coupon: any) => (coupon.coupon_id === item.obj_id))
    //             })
    //             const uniqeEventId: any = _.uniq(eventList)
    //             if (uniqeEventId.length > 0) {
    //               getEvents(uniqeEventId).then((events: SportEvent[]) => {
    //                 for (let event of events) {
    //                   societywonEventIdMapping[Number(event.eventId.toString())] = event;
    //                 }
    //                 fillEventStatistics(uniqeEventId).then(()=>{
    //                   posts.push(...response)
    //                   setPage(page + 1);
    //                 }).catch(()=>{
    //                   posts.push(...response)
    //                   setPage(page + 1);
    //                 })
    //               })
    //             } else {
    //               posts.push(...response)
    //               setPage(page + 1);
    //             }
    //           });
    //         })
    //       } else {
    //         setPage(page + 1);
    //       }
    //     });
    //   }
    // }
    if (posts === null || posts.length === 0) {
        var loading = document.getElementById('innerLoading');
        if (loading)
            loading.style.display = 'unset';
        setTimeout(function () {
            var loading = document.getElementById('innerLoading');
            if (loading)
                loading.style.display = 'none';
        }, 1000);
        if (posts === null) {
            return _jsx(_Fragment, {}, void 0);
        }
    }
    function onLocation(selectlocation) {
        var object = new Location();
        object.path = selectlocation;
        Object.assign(location, object);
        navigate(base + '/giris-yap');
    }
    return (_jsxs("div", __assign({ className: "card social-profile" }, { children: [_jsxs("div", __assign({ className: "card-title" }, { children: [_jsxs("h2", __assign({ className: "w-100" }, { children: [_jsx("div", __assign({ className: "profile" }, { children: pages[props.subpage].title === 'Profilim' || pages[props.subpage].title === 'Profil' ? (userInfo && userInfo.photo ?
                                    _jsx("img", { className: "avatar hidden-sm profile-avatar", src: env.core_api + "/" + userInfo.photo, alt: "" }, void 0) :
                                    _jsx("img", { className: "avatar hidden-sm profile-avatar", src: DefaultAvatar, alt: "" }, void 0)) : '' }), void 0), (props.subpage === 'profilim' || props.subpage === 'profil') && userInfo ? (member.id ? _jsx("div", __assign({ className: 'float-right' }, { children: !member.following.includes(Number(profileMember)) ?
                                    (profileMember !== member.id) ? (_jsx("button", __assign({ onClick: function (e) {
                                            followActions(Number(profileMember), 'add', e).then(function () {
                                                forceUpdate();
                                            });
                                        }, className: "btn btn-small btn-warning float-right" }, { children: "Takip Et" }), void 0)) : (_jsx(_Fragment, {}, void 0))
                                    :
                                        _jsx("button", __assign({ onClick: function (e) {
                                                followActions(Number(profileMember), 'unfollow', e).then(function () {
                                                    forceUpdate();
                                                });
                                            }, className: "btn btn-small btn-outline-warning float-right" }, { children: "Takibi B\u0131rak" }), void 0) }), void 0) :
                                _jsx(_Fragment, { children: _jsx("button", __assign({ onClick: function () {
                                            onLocation(window.location.pathname);
                                        }, className: "btn btn-small btn-warning float-right" }, { children: "Takip Et" }), void 0) }, void 0)) : (_jsx(_Fragment, {}, void 0)), (props.subpage === 'profilim' || props.subpage === 'profil') && userInfo ? (_jsxs("div", __assign({ className: "nickname" }, { children: [_jsxs(Link, __assign({ to: '/societywon/' + (profileMember === member.id ? 'profilim' : 'profil') + '/' + profileMember + '/kuponlarim/' }, { children: ["@", userInfo.nick_name] }), void 0), _jsx("br", {}, void 0), userInfo.title != undefined && userInfo.title != "" && userInfo.title != null ? (_jsx("div", __assign({ className: "nickname d-flex align-items-center", style: { height: "100%" } }, { children: _jsxs("div", __assign({ className: 'fw-bold fs-small text-dark d-flex' }, { children: ["Uzmanl\u0131k : ", _jsxs("p", __assign({ className: 'm-0 fs-small fw-normal text-dark' }, { children: ["\u00A0", userInfo.title] }), void 0)] }), void 0) }), void 0)) : null, (props.subpage === 'profilim' || props.subpage === 'profil') && userInfo ? _jsx(_Fragment, { children: _jsxs("div", __assign({ className: "social-info float-left " }, { children: [_jsxs("a", __assign({ className: "cursor-pointer text-center m-0", style: {
                                                        background: contentType === 'takipciler' ? 'var(--color-bg-light)' : 'transparent',
                                                        border: '0'
                                                    }, onClick: function () {
                                                        navigate('/societywon/' + props.subpage + (['profilim', 'profil'].includes(props.subpage) ? '/' + profileMember : '') + '/takipciler/');
                                                        setPage(1);
                                                        setPosts([]);
                                                        setHasMore(true);
                                                    } }, { children: [" ", _jsx("span", { children: userInfo.followers_count }, void 0), " Takip\u00E7i"] }), void 0), _jsxs("a", __assign({ className: "cursor-pointer text-center border-0", style: {
                                                        background: contentType === 'takip-edilenler' ? 'var(--color-bg-light)' : 'transparent',
                                                        border: '0'
                                                    }, onClick: function () {
                                                        navigate('/societywon/' + props.subpage + (['profilim', 'profil'].includes(props.subpage) ? '/' + profileMember : '') + '/takip-edilenler/');
                                                        setPage(1);
                                                        setPosts([]);
                                                        setHasMore(true);
                                                    } }, { children: [" ", _jsx("span", { children: userInfo.following_count }, void 0), " Takip"] }), void 0), _jsxs("a", __assign({ className: "cursor-pointer text-center border-0", style: {
                                                        background: contentType === 'tumu' ? 'var(--color-bg-light)' : 'transparent',
                                                        border: '0'
                                                    }, onClick: function () {
                                                        navigate('/societywon/' + props.subpage + (['profilim', 'profil'].includes(props.subpage) ? '/' + profileMember : '') + '/tumu/');
                                                        setPage(1);
                                                        setPosts([]);
                                                        setHasMore(true);
                                                    } }, { children: [_jsx("span", { children: userInfo.post_count }, void 0), " Payla\u015F\u0131m"] }), void 0)] }), void 0) }, void 0) : _jsx(_Fragment, {}, void 0)] }), void 0)) : (_jsx(_Fragment, { children: pages[props.subpage].title }, void 0))] }), void 0), _jsx("div", __assign({ className: "visible-sm w-100" }, { children: _jsx("div", __assign({ className: "visible-sm w-100 mobile-header" }, { children: (props.subpage == 'profil' || props.subpage == 'profilim') && userInfo ? (_jsxs("div", __assign({ className: "w-100", style: { borderBottom: "1px solid var(--color-bg-medium)" } }, { children: [_jsx("div", { children: _jsxs("div", __assign({ className: "header" }, { children: [_jsx("img", { src: ReturnIcon, className: 'm-3 invert-color', width: 21, height: 21, onClick: function () { return history.back(); }, alt: "" }, void 0), _jsx("div", __assign({ className: "float-right m-3" }, { children: member.id ? _jsx(_Fragment, { children: !member.following.includes(Number(profileMember)) ?
                                                            (profileMember !== member.id) ? (_jsx("button", __assign({ onClick: function (e) {
                                                                    followActions(Number(profileMember), 'add', e).then(function () {
                                                                        forceUpdate();
                                                                    });
                                                                }, className: "btn btn-small btn-warning float-right" }, { children: "Takip Et" }), void 0)) : (_jsx(_Fragment, {}, void 0))
                                                            :
                                                                _jsx("button", __assign({ onClick: function (e) {
                                                                        followActions(Number(profileMember), 'unfollow', e).then(function () {
                                                                            forceUpdate();
                                                                        });
                                                                    }, className: "btn btn-small btn-outline-warning float-right" }, { children: "Takibi B\u0131rak" }), void 0) }, void 0) :
                                                        _jsx(_Fragment, { children: _jsx("button", __assign({ onClick: function () {
                                                                    onLocation(window.location.pathname);
                                                                }, className: "btn btn-small btn-warning float-right" }, { children: "Takip Et" }), void 0) }, void 0) }), void 0), _jsxs("div", __assign({ className: "member py-3" }, { children: [_jsx("div", { children: _jsx("img", { className: "avatar", width: 45, src: userInfo.photo ? env.societywon_api + userInfo.photo : DefaultAvatar, style: { height: '45px !important' } }, void 0) }, void 0), _jsx("div", __assign({ className: "nickname d-flex align-items-center justify-content-center", style: { height: "100%" } }, { children: _jsxs(Link, __assign({ className: "ml-2 fw-bold", to: '/societywon/' + (profileMember === member.id ? 'profilim' : 'profil') + '/' + profileMember + '/kuponlarim/' }, { children: ["@", userInfo.nick_name] }), void 0) }), void 0), userInfo.title != undefined && userInfo.title != "" && userInfo.title != null ? (_jsx("div", __assign({ className: "nickname d-flex align-items-center", style: { height: "100%" } }, { children: _jsxs("div", __assign({ className: 'fw-bold fs-small text-dark d-flex' }, { children: ["Uzmanl\u0131k : ", _jsxs("p", __assign({ className: 'm-0 fs-small fw-normal text-dark' }, { children: ["\u00A0", userInfo.title] }), void 0)] }), void 0) }), void 0)) : null] }), void 0)] }), void 0) }, void 0), _jsxs("div", __assign({ className: "mb-3 d-flex justify-content-around" }, { children: [_jsxs("div", __assign({ className: "col-3", onClick: function () {
                                                    navigate('/societywon/' + props.subpage + (['profilim', 'profil'].includes(props.subpage) ? '/' + profileMember : '') + '/tumu/');
                                                    setPage(1);
                                                    ;
                                                    setPosts([]);
                                                    setHasMore(true);
                                                } }, { children: [_jsx("div", __assign({ className: "col d-flex justify-content-center" }, { children: "Payla\u015F\u0131m" }), void 0), _jsx("div", __assign({ className: "col d-flex justify-content-center fw-bold" }, { children: userInfo.post_count }), void 0)] }), void 0), _jsxs("div", __assign({ className: "col-3", onClick: function () {
                                                    navigate('/societywon/' + props.subpage + (['profilim', 'profil'].includes(props.subpage) ? '/' + profileMember : '') + '/takipciler/');
                                                    setPage(1);
                                                    setHasMore(true);
                                                } }, { children: [_jsx("div", __assign({ className: "col d-flex justify-content-center" }, { children: "Takip\u00E7i" }), void 0), _jsx("div", __assign({ className: "col d-flex justify-content-center fw-bold" }, { children: userInfo.followers_count }), void 0)] }), void 0), _jsxs("div", __assign({ className: "col-3", onClick: function () {
                                                    navigate('/societywon/' + props.subpage + (['profilim', 'profil'].includes(props.subpage) ? '/' + profileMember : '') + '/takip-edilenler/');
                                                    setPage(1);
                                                    setHasMore(true);
                                                } }, { children: [_jsx("div", __assign({ className: "col d-flex justify-content-center" }, { children: "Takip" }), void 0), _jsx("div", __assign({ className: "col d-flex justify-content-center fw-bold" }, { children: userInfo.following_count }), void 0)] }), void 0)] }), void 0)] }), void 0)) : (null) }), void 0) }), void 0), _jsx("div", { className: "clearfix" }, void 0), _jsx("div", __assign({ className: "actions" }, { children: ['profilim', 'profil', 'zaman-tuneli', 'takip-ettiklerimin-paylasimlari', 'anasayfa'].includes(props.subpage) ? _jsxs(_Fragment, { children: [_jsx("a", __assign({ onClick: function () {
                                        navigate('/societywon/' + props.subpage + (['profilim', 'profil'].includes(props.subpage) ? '/' + profileMember : '') + '/kuponlarim/');
                                        setPage(1);
                                        ;
                                        setPosts([]);
                                        setHasMore(true);
                                    }, className: "tab " + (contentType === 'kuponlarim' ? 'active' : '') }, { children: "Kuponlar" }), void 0), ['zaman-tuneli', 'profil', 'takip-ettiklerimin-paylasimlari', 'anasayfa'].includes(props.subpage) ? _jsx(_Fragment, { children: _jsx("a", __assign({ onClick: function () {
                                            navigate('/societywon/' + props.subpage + (['profilim', 'profil'].includes(props.subpage) ? '/' + profileMember : '') + '/tuyolar/');
                                            setPage(1);
                                            ;
                                            setPosts([]);
                                            setHasMore(true);
                                        }, className: "tab " + (contentType === 'tuyolar' ? 'active' : '') }, { children: "T\u00FCyolar\u0131 G\u00F6ster" }), void 0) }, void 0) : _jsx(_Fragment, { children: profileMember == member.id ? (_jsx("a", __assign({ onClick: function () {
                                            navigate('/societywon/' + props.subpage + (['profilim'].includes(props.subpage) ? '/' + profileMember : '') + '/begendiklerim/');
                                            setPage(1);
                                            ;
                                            setPosts([]);
                                            setHasMore(true);
                                        }, className: "tab " + (contentType === 'begendiklerim' ? 'active' : '') }, { children: "Be\u011Fendiklerim" }), void 0)) : (_jsx("a", __assign({ onClick: function () {
                                            navigate('/societywon/' + props.subpage + (['profilim'].includes(props.subpage) ? '/' + profileMember : '') + '/begendiklerim/');
                                            setPage(1);
                                            ;
                                            setPosts([]);
                                            setHasMore(true);
                                        }, className: "tab " + (contentType === 'begendiklerim' ? 'active' : '') }, { children: "Be\u011Fendikleri" }), void 0)) }, void 0), _jsx("a", __assign({ onClick: function () {
                                        navigate('/societywon/' + props.subpage + (['profilim', 'profil'].includes(props.subpage) ? '/' + profileMember : '') + '/tumu/');
                                        setPage(1);
                                        setPosts([]);
                                        setHasMore(true);
                                    }, className: "tab " + (contentType === 'tumu' ? 'active' : '') }, { children: "Hepsini G\u00F6r" }), void 0)] }, void 0) : _jsx(_Fragment, {}, void 0) }), void 0), props.subpage === 'en-populer-kuponlar' || contentType === 'kuponlarim' ? _jsx(_Fragment, { children: _jsxs("div", __assign({ className: "actions text-right", style: { display: 'block' } }, { children: [_jsx("a", __assign({ onClick: function () { return setParams({ ordering: '-create_date' }); }, className: "sort hidden-sm " + (ordering === '-create_date' ? 'active' : '') }, { children: "G\u00FCncel" }), void 0), _jsx("a", __assign({ onClick: function () { return setParams({ ordering: '-comment_count' }); }, className: "sort hidden-sm " + (ordering === '-comment_count' ? 'active' : '') }, { children: "Yorum" }), void 0), _jsx("a", __assign({ onClick: function () { return setParams({ ordering: '-like_count' }); }, className: "sort hidden-sm " + (ordering === '-like_count' ? 'active' : '') }, { children: "Be\u011Feni" }), void 0), _jsx("a", __assign({ onClick: function () { return setParams({ ordering: '-profit' }); }, className: "sort " + (ordering === '-profit' ? 'active' : '') }, { children: "Kazan\u00E7" }), void 0), _jsx("a", __assign({ onClick: function () { return setParams({ ordering: '-total_ratio' }); }, className: "sort " + (ordering === '-total_ratio' ? 'active' : '') }, { children: "Oran" }), void 0), _jsx("a", __assign({ onClick: function () { return setParams({ ordering: '-amount' }); }, className: "sort " + (ordering === '-amount' ? 'active' : '') }, { children: "Tutar" }), void 0), _jsx("a", __assign({ onClick: function () { return setParams({ ordering: '-hit' }); }, className: "sort " + (ordering === '-hit' ? 'active' : '') }, { children: "Oynama" }), void 0)] }), void 0) }, void 0) : _jsx(_Fragment, {}, void 0)] }), void 0), posts.length === 0 ? _jsx(_Fragment, { children: _jsxs("div", __assign({ className: "my-3 " }, { children: [_jsxs("span", __assign({ className: "text-center d-flex justify-content-center" }, { children: ["Hen\u00FCz listelenecek bir payla\u015F\u0131m bulunamam\u0131\u015Ft\u0131r.", _jsx("br", {}, void 0), "Daha fazla payla\u015F\u0131m i\u00E7in;"] }), void 0), _jsx("br", {}, void 0), _jsx("div", __assign({ className: "d-flex justify-content-center" }, { children: _jsx("button", __assign({ className: "btn btn-outline-primary" }, { children: _jsx(Link, __assign({ to: "/societywon/zaman-tuneli/kuponlarim/" }, { children: "Zaman T\u00FCneli" }), void 0) }), void 0) }), void 0)] }), void 0) }, void 0) : _jsx(_Fragment, {}, void 0), _jsx("div", __assign({ className: "card-body entries p-0" }, { children: _jsx(InfiniteScroll, __assign({ dataLength: posts.length, next: fetchMoreData, hasMore: hasMore, loader: _jsx("div", __assign({ className: "p-5" }, { children: _jsxs("div", __assign({ className: "lds-roller" }, { children: [_jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0)] }), void 0) }), void 0), endMessage: _jsx(_Fragment, {}, void 0) }, { children: _jsx("div", {}, void 0) }), void 0) }), void 0)] }), void 0));
}
